import { createSlotRecipe } from './runtime';

const choiceConfig = {"name":"choice","slots":["root","input","label","description"],"defaultVariants":{"type":"checkbox"},"variantMap":{"type":["checkbox","radio"]}}

export const choice = /* @__PURE__ */ createSlotRecipe(choiceConfig)